<script lang="ts">
  import type { Snippet } from 'svelte';
  const { radius, x, y, children }: { radius: number; x: number; y: number; children: Snippet } = $props();
  const r = $derived(radius);
</script>

<g style:transform='translate({x}px {y}px)'>
  <path
    id=streak-path
    fill=transparent
    d="
      M {x} {y}
      m {r}, 0
      a {r},{r} 0 1,0 -{r * 2},0
      a {r},{r} 0 1,0  {r * 2},0
    "
  />
  {@render children()}
</g>